export const configUpdateTableId = 'configurationBatchUpdate';

export const configUpdateDefaultSorting = { id: 'c_uuid', desc: false };

export const excludedFields = [
  'details',
  'end_time',
  'f_status',
  'new_firmware_version',
  'current_firmware_version',
  'request_time',
  'time',
  'user_name',
  'customer_id',
];

export const TECHNICAL_INFO_FIELDS = ['enclosure', 'product_level', 'product_version'];

export const includedFields = [
  { name: 'configuration_update_username', label: 'Username', valueEditorType: 'text' },
  { name: 'configuration_update_ts', label: 'Update Date/Time (UTC)', valueEditorType: 'date' },
];

export const confirmationBodyText = 'You have unsaved changes. Do you want to leave and discard your changes?';
